import { ENTRY_TYPE } from '../../domain/enum/entry-type.enum';
import { IApiEntry } from '../../../../../shared/infrastructure/dto/entry-api.interface';

/**
 * Mock for a standard restaurant entry - Paella Valenciana
 * Represents a typical main dish with normal pricing
 */
export const entryApiMock1: IApiEntry = {
  _id: 'entry_550e8400e29b41d4a716446655440001',
  negocio_id: '6507f1f45e88bd1a92b30001',
  account_id: '6507f1f45e88bd1a92b30003',
  product_id: 'product_001',
  product_name: 'Paella Valenciana',
  associated_id: 'associated_001',
  associated_name: 'Platos Principales',
  quantity: 1,
  quantity_to_display: 1,
  unit_price: 18.50,
  initial_unit_price: 18.50,
  total: 18.50,
  initial_total: 18.50,
  sale_format_name: 'Ración completa',
  vat: 21,
  taxes_ids: ['tax_001'],
  selected_addons: [],
  addons_total: 0,
  type: ENTRY_TYPE.product,
  created_at: 1703847600000,
  created_by: 'admin',
  updated_at: 1703847600000,
  updated_by: 'admin'
};

/**
 * Mock for a beverage entry - Sangría (multiple units)
 * Represents a beverage item with quantity > 1
 */
export const entryApiMock2: IApiEntry = {
  _id: 'entry_550e8400e29b41d4a716446655440002',
  negocio_id: '6507f1f45e88bd1a92b30001',
  account_id: '6507f1f45e88bd1a92b30003',
  product_id: 'product_002',
  product_name: 'Sangría (1L)',
  associated_id: 'associated_002',
  associated_name: 'Bebidas',
  quantity: 2,
  quantity_to_display: 2,
  unit_price: 12.00,
  initial_unit_price: 12.00,
  total: 24.00,
  initial_total: 24.00,
  sale_format_name: 'Jarra familiar',
  vat: 21,
  taxes_ids: ['tax_001'],
  selected_addons: [],
  addons_total: 0,
  type: ENTRY_TYPE.product,
  created_at: 1703847600000,
  created_by: 'admin',
  updated_at: 1703847600000,
  updated_by: 'admin'
};

/**
 * Mock for a refund entry - Postre del día (negative quantity for refunds)
 * Represents a refunded dessert item with negative values
 */
export const entryApiMock3: IApiEntry = {
  _id: 'entry_550e8400e29b41d4a716446655440003',
  negocio_id: '6507f1f45e88bd1a92b30001',
  account_id: '6507f1f45e88bd1a92b30003',
  product_id: 'product_003',
  product_name: 'Postre del día',
  associated_id: 'associated_003',
  associated_name: 'Postres',
  quantity: -1,
  quantity_to_display: -1, // Negative for refund
  unit_price: 6.50,
  initial_unit_price: 6.50,
  total: -6.50,
  initial_total: 6.50,
  sale_format_name: 'Porción individual',
  vat: 21,
  taxes_ids: ['tax_001'],
  selected_addons: [],
  addons_total: 0,
  type: ENTRY_TYPE.product,
  created_at: 1703851200000,
  created_by: 'admin',
  updated_at: 1703851200000,
  updated_by: 'admin'
};

/**
 * Mock for an entry with addons - Hamburguesa Gourmet with extras
 * Represents a product with selected addons and modified pricing
 */
export const entryApiMock4: IApiEntry = {
  _id: 'entry_550e8400e29b41d4a716446655440004',
  negocio_id: '6507f1f45e88bd1a92b30001',
  account_id: '6507f1f45e88bd1a92b30007',
  product_id: 'product_004',
  product_name: 'Hamburguesa Gourmet',
  associated_id: 'associated_004',
  associated_name: 'Especialidades',
  quantity: 1,
  quantity_to_display: 1,
  unit_price: 14.90,
  initial_unit_price: 14.90,
  total: 18.40, // Includes addons total
  total_addons: 3.50,
  initial_total: 14.90,
  sale_format_name: 'Con guarnición',
  vat: 21,
  taxes_ids: ['tax_001'],
  selected_addons: [
    {
      addon: {
        _id: 'addon_001',
        product_id: 'addon_product_001',
        amount: 2.50,
        created_at: 1703847600000,
        created_by: 'admin'
      },
      quantity: 1,
      total: 2.50
    },
    {
      addon: {
        _id: 'addon_002',
        product_id: 'addon_product_002',
        amount: 1.00,
        created_at: 1703847600000,
        created_by: 'admin'
      },
      quantity: 1,
      total: 1.00
    }
  ],
  addons_total: 3.50,
  type: ENTRY_TYPE.product,
  created_at: 1703847600000,
  created_by: 'admin',
  updated_at: 1703847600000,
  updated_by: 'admin'
};

/**
 * Mock for a discounted entry - Ensalada César with percentage discount
 * Represents a product with applied discount
 */
export const entryApiMock5: IApiEntry = {
  _id: 'entry_550e8400e29b41d4a716446655440005',
  negocio_id: '6507f1f45e88bd1a92b30001',
  account_id: '6507f1f45e88bd1a92b30007',
  product_id: 'product_005',
  product_name: 'Ensalada César',
  associated_id: 'associated_005',
  associated_name: 'Ensaladas',
  quantity: 1,
  quantity_to_display: 1,
  unit_price: 9.50,
  initial_unit_price: 11.80,
  total: 9.50,
  initial_total: 11.80,
  sale_format_name: 'Ensalada completa',
  vat: 21,
  taxes_ids: ['tax_001'],
  discount: {
    price_discount: 0,
    percentage_discount: 20,
    price_percentage_discount: 2.30
  },
  selected_addons: [],
  addons_total: 0,
  type: ENTRY_TYPE.product,
  created_at: 1703847600000,
  created_by: 'admin',
  updated_at: 1703847600000,
  updated_by: 'admin'
};

/**
 * Mock for a booking-type entry
 * Represents a special booking or reservation entry
 */
export const entryApiMock6: IApiEntry = {
  _id: 'entry_550e8400e29b41d4a716446655440006',
  negocio_id: '6507f1f45e88bd1a92b30001',
  account_id: '6507f1f45e88bd1a92b30007',
  product_id: '',
  product_name: 'Reserva Mesa VIP - Exclusividad de zona',
  associated_id: 'booking_001',
  associated_name: 'Servicios de reserva',
  quantity: 1,
  quantity_to_display: 1,
  unit_price: 25.00,
  initial_unit_price: 25.00,
  total: 25.00,
  initial_total: 25.00,
  vat: 10,
  taxes_ids: ['tax_002'],
  selected_addons: [],
  addons_total: 0,
  type: ENTRY_TYPE.booking,
  created_at: 1703934000000,
  created_by: 'admin',
  updated_at: 1703934000000,
  updated_by: 'admin'
};

/**
 * Array containing all entry API mocks for easy access
 */
export const entryApiMocks: IApiEntry[] = [
  entryApiMock1,
  entryApiMock2,
  entryApiMock3,
  entryApiMock4,
  entryApiMock5,
  entryApiMock6
];

/**
 * Helper function to get an entry API mock by ID
 * @param id - The entry ID to search for
 * @returns The entry API mock or undefined if not found
 */
export function getEntryApiMockById(id: string): IApiEntry | undefined {
  return entryApiMocks.find(entry => entry._id === id);
}

/**
 * Helper function to get entry API mocks by type
 * @param type - The entry type to filter by
 * @returns Array of entry API mocks matching the type
 */
export function getEntryApiMocksByType(type: ENTRY_TYPE): IApiEntry[] {
  return entryApiMocks.filter(entry => entry.type === type);
}

/**
 * Helper function to get entries with addons
 * @returns Array of entry API mocks that have selected addons
 */
export function getEntriesApiWithAddons(): IApiEntry[] {
  return entryApiMocks.filter(entry => entry.selected_addons && entry.selected_addons.length > 0);
}

/**
 * Helper function to get entries with discounts
 * @returns Array of entry API mocks that have discounts applied
 */
export function getEntriesApiWithDiscounts(): IApiEntry[] {
  return entryApiMocks.filter(entry => entry.discount !== undefined);
}

/**
 * Helper function to get refund entries (negative quantities)
 * @returns Array of entry API mocks with negative quantities
 */
export function getRefundEntriesApi(): IApiEntry[] {
  return entryApiMocks.filter(entry => entry.quantity < 0);
}
